import { IconButton, IconButtonSize, IconButtonTheme } from '@apply/components';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

interface ClearBorrowerEntityButtonProps {
    borrowerEntityId: number | undefined;
    onClear: () => void;
    disabled: boolean;
}

/** Removes the selected borrower entity; hidden while there's none. */
export const ClearBorrowerEntityButton = ({ borrowerEntityId, onClear, disabled }: ClearBorrowerEntityButtonProps) => {
    if (!borrowerEntityId) {
        return null;
    }

    return (
        <IconButton
            id='borrowerEntityClear'
            theme={IconButtonTheme.DarkBlueActive}
            size={IconButtonSize.ExtraSmall}
            icon={faTimes}
            hint='Remove selected entity'
            disabled={disabled}
            handleClick={onClear}
        />
    );
};
